import {
    GETLOADLIMITLIST_SUCCESS,
    GETLOADLIMITLIST_FAILED,
    RESET_GETLOADLIMITLIST,
    LOADING_GETLOADLIMITLIST,
    NETWORK_ERROR_GETLOADLIMITLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetLoadLimitList = () => {
    return { type: RESET_GETLOADLIMITLIST };
};

const getLoadLimitList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETLOADLIMITLIST });
    await partnerServices
        .post("getLoadLimitList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getLoadLimitListsuccess(res.data));
                    break;
                default:
                    dispatch(getLoadLimitListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETLOADLIMITLIST, payload: err });
        });
};
function getLoadLimitListsuccess(data) {
    return {
        type: GETLOADLIMITLIST_SUCCESS,
        payload: data,
    };
}
function getLoadLimitListFailed(data) {
    return {
        type: GETLOADLIMITLIST_FAILED,
        payload: data,
    };
}

export { resetGetLoadLimitList, getLoadLimitList };
